import * as React from 'react';
import { SkeletonBodyCopy, SkeletonButton, SkeletonCard, SkeletonHeadline, SkeletonImage, SkeletonProfileImage, } from '..';
import * as Styled from './skeleton-card.styles';
export const SkeletonCardPreset = ({ className, variant, ...props }) => (React.createElement(React.Fragment, null,
    variant === 'profile' && (React.createElement(SkeletonCard, { className: className, ...props },
        React.createElement(Styled.ImageContainer, null,
            React.createElement(SkeletonProfileImage, { size: "small" })),
        React.createElement(Styled.CardHeadline, { amountRows: 1 }),
        React.createElement(SkeletonBodyCopy, { amountRows: 3 }))),
    variant === 'text' && (React.createElement(SkeletonCard, { className: className, ...props },
        React.createElement(Styled.FlexContainer, null,
            React.createElement("div", null,
                React.createElement(Styled.CardHeadline, { amountRows: 1 }),
                React.createElement(SkeletonBodyCopy, { amountRows: 3 })),
            React.createElement(Styled.ButtonContainer, null,
                React.createElement(SkeletonButton, null))))),
    variant === 'image' && (React.createElement(SkeletonCard, { className: className, noPadding: true, ...props },
        React.createElement(SkeletonImage, { width: "100%", height: "220px" }),
        React.createElement(Styled.ImageCardContent, null,
            React.createElement(SkeletonHeadline, null))))));
SkeletonCardPreset.displayName = 'SkeletonCardPreset';
//# sourceMappingURL=skeleton-card.preset.js.map